// WebAuthn passkey browser glue. spatie/laravel-passkeys ships Blade partials
// (createScript / authenticateScript) that call `startRegistration`, `startAuthentication`,
// and `browserSupportsWebAuthn` as bare globals. SimpleWebAuthn v13 is an ES module, so we
// import it here and re-expose those names on `window`. Imported by both guest.js (login page)
// and app.js (profile registration + /auth nudge).
import {
    startRegistration,
    startAuthentication,
    browserSupportsWebAuthn,
} from '@simplewebauthn/browser';

window.startRegistration = startRegistration;
window.startAuthentication = startAuthentication;
window.browserSupportsWebAuthn = browserSupportsWebAuthn;
